export enum AgentType {
    Shareholder = 'Cotista'
}
